import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch2, fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
    success: boolean;
    data: any;
    message?: string;
}

export const useServicesCreateMutation = () => {
    return useMutation({
        mutationFn: async (payload: any) => {
            console.log("payload >>>>>>>>>>>>", payload);

            const res: ApiResponse = await fetch4(`${url}/api/service/`, payload);

            // Manually throw error if success is false
            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res.data;
        },
        onSuccess: (data: any) => {
            console.log("✅ Services Created successfully:", data);
        },
        onError: (error: any) => {
            console.error("❌ Services create request failed:", error.message);
        },
    });
};

export const useFetchServicesData = (
    page: number,
    limit: number,
    searchFor: string
) => {
    return useQuery({
        queryKey: ["servicesData", page, limit, searchFor],
        queryFn: async () => {
            const res = await fetch3(
                `${url}/api/service?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }

            return res.data; // 👈 This returns your full user object
        },
        staleTime: 1000 * 60 * 5,
    });
};
interface UpdateServicePayload {
    id: string;
    name: any; // Add more statuses if needed
}
export const useUpdateService = () => {
    return useMutation({
        mutationFn: async ({ id, name }: UpdateServicePayload) => {
            const res: ApiResponse = await fetch5(
                `${url}/api/service/${id}`,
                "PUT",
                { name }
            );

            if (!res.success) {
                throw new Error(res.message || "Failed to update vehicle status");
            }

            return res.data;
        },
        onSuccess: (data: any) => {
            console.log("✅ Services Created successfully:", data);
        },
        onError: (error: any) => {
            console.error("❌ Services create request failed:", error.message);
        },
    });
};
